import { Layout } from "@certn/cascadia-react";
import { PropsWithChildren } from "react";

import { SettingsNavigation } from "./SettingsNavigation";
import { AppFooterLinks } from "../../components/app-footer/AppFooterLinks";
import { AppHeader } from "../../components/app-header/AppHeader";

export function SettingsLayout({ children }: PropsWithChildren) {
  return (
    <Layout
      layout="wide"
      header={<AppHeader />}
      navigation={<SettingsNavigation />}
      footer={<AppFooterLinks />}
    >
      {children}
    </Layout>
  );
}
